<script setup>
import SquareScore from '@/Components/Chart/SquareScore.vue';
import Card from '@/Components/Card/Card.vue';
import Pill from '@/Components/Pill.vue';
</script>

<template>
  <Card class="z-10 px-0! sm:flex">
    <div class="flex flex-col items-center gap-6">
      <div class="font-bold">
        {{ $t('domain_score.partials.privacy_card.privacy') }}
      </div>
      <SquareScore :score="5" />
      <div>{{ $t('domain_score.partials.privacy_card.low_risk') }}</div>
      <div class="flex flex-wrap justify-center gap-1">
        <Pill>{{ $t('domain_score.partials.privacy_card.tlsrpt') }}</Pill>
        <Pill>{{ $t('domain_score.partials.privacy_card.mtasts') }}</Pill>
      </div>
    </div>
  </Card>
</template>
